// config
export const configFooter = 'config.footer';
const configPreHeader = 'config.preHeader';
const configHeader = 'config.header';
export const configNotFoundPage = 'config.notFoundPage';
// page
const pageHeader = 'page.customHeader';
const pagePreHeader = 'page.customPreHeader';
// article
const blogArticleHeader = 'article.customHeader';
const blogArticlePreHeader = 'article.customPreHeader';
const articleAuthor = 'article.author';
const articleCategories = 'article.categories';
// article author
const blogArticleAuthorHeader = 'articleAuthor.customHeader';
const blogArticleAuthorPreHeader = 'articleAuthor.customPreHeader';
// article category
const blogArticleCategoryHeader = 'articleCategory.customHeader';
const blogArticleCategoryPreHeader = 'articleCategory.customPreHeader';
// recommended articles
const recommendedArticlesAsd = 'blogArticlesByFilters.recommendedArticles';
// career offer
const careerOfferAuthorHeader = 'careerOffer.customHeader';
const careerOfferAuthorPreHeader = 'careerOffer.customPreHeader';
const careerOfferLocations = 'careerOffer.locations';
// articleCard
const articleCard = 'blogArticleCard.article';
// advanced seo
const colletionPageJsonLd = 'collectionPageJsonLd.hasPart';

export const relationsArr = [
  pagePreHeader,
  configFooter,
  configPreHeader,
  configHeader,
  configNotFoundPage,
  pageHeader,
  blogArticlePreHeader,
  blogArticleHeader,
  blogArticleAuthorHeader,
  blogArticleAuthorPreHeader,
  blogArticleCategoryHeader,
  blogArticleCategoryPreHeader,
  recommendedArticlesAsd,
  careerOfferAuthorHeader,
  careerOfferAuthorPreHeader,
  careerOfferLocations,
  articleCard,
  articleAuthor,
  articleCategories,
  colletionPageJsonLd,
] as const;

export type Relation = (typeof relationsArr)[number];

export const relations = relationsArr.join(',');
